export default __webpack_public_path__ + "static/media/divider.d675e69f.svg";